import { type FirebaseOptions, initializeApp } from "firebase/app";
import { getMessaging, isSupported, type Messaging } from "firebase/messaging";
import { config } from "../config";
import logger from "./logger";

const app = initializeApp(config.firebase as FirebaseOptions);

// Messaging is created only when push is used (the user turned notifications on, or they were on before), never at
// import: nothing push-related runs or is stored before the user's tap (privacy consent, Task 17).
// getMessaging() starts its own support probe and rejects it, unhandled, in browsers without the required APIs
// (messaging/unsupported-browser). Probe first and only create the instance when supported. The promise settles
// with null when unsupported or failed and never rejects.
let messagingPromise: Promise<Messaging | null> | null = null;

export function getMessagingLazy(): Promise<Messaging | null> {
  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then((ok) => {
        if (!ok) {
          logger.warn("[FCM] Messaging is not supported in this browser");
          return null;
        }
        return getMessaging(app);
      })
      .catch((e) => {
        logger.warn("[FCM] getMessaging() failed:", e);
        return null;
      });
  }
  return messagingPromise;
}

export { app };
